import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';

import {
  Button,
  Grid,
  GridRow,
  GridColumn,
  Dropdown,
  Popup,
} from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';

import {
  getMainIncome,
  getIncomeBracket,
  postCreateUpdate,
  getCanCreateNew,
} from './state/actions';

import { Filter, Main } from '../../containers/';
import { NotificationMessage } from 'Components';
import { columns } from './helpers/columns';

const title = 'Income Brackets';

class IncomeBracketContainer extends Component {
  state = {
    selectedFiscalYear: 0,
    selectedMainIncomeId: undefined,
    isOpen: false,
  };

  componentWillMount() {
    this.props.getMainIncome();
    this.props.getCanCreateNew();
  }

  componentWillReceiveProps(nextProps) {
    const { apiResult, canCreateNew } = nextProps;

    if (apiResult && apiResult !== this.props.apiResult) {
      NotificationMessage(apiResult);
    }

    if (canCreateNew === 0) {
      this.setState({ isOpen: false });
    }
  }

  getIncomeBrackets = (e, data) => {
    this.props.getIncomeBracket(data.value);
    this.setState({ selectedMainIncomeId: data.value });

    //store selected fiscal year in local state
    const key = data.options.filter(x => {
      return x.value === data.value;
    });

    if (key) {
      this.setState({ selectedFiscalYear: parseInt(key[0].key, 10) });
    }
  };

  createUpdate = () => {
    const { selectedFiscalYear, selectedMainIncomeId } = this.state;
    this.props.postCreateUpdate(
      selectedFiscalYear,
      'UPDATE',
      selectedMainIncomeId
    );
  };

  createIncomeBracket = () => {
    this.props.postCreateUpdate(
      this.props.canCreateNew,
      'CREATE',
      this.state.selectedMainIncomeId
    );
  };

  handleOpen = () => {
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const {
      fetchingMainIncome,
      fetchingIncomeBracket,
      mainIncomes,
      incomeBrackets,
      fetchingUpdate,
      fetchingCreate,
      canCreateNew,
      isReadOnly,
    } = this.props;

    const { selectedFiscalYear } = this.state;

    const transformedData = mainIncomes.map(main => ({
      key: main.FiscalYear,
      text: `${main.FiscalYear} by ${main.UserName} on ${moment(
        main.LastModifiedDT
      ).format('MM/DD/YYYY')}`,
      value: main.id,
    }));

    const index = _.findIndex(incomeBrackets, x => {
      return x.FamilySize === 9;
    });

    if (incomeBrackets[index] !== undefined) {
      incomeBrackets[index].FamilySize = 'Additional';
    }

    return (
      <Fragment>
        <Filter title={title}>
          <Grid>
            <GridRow>
              <GridColumn width="8" floated="left">
                <Dropdown
                  placeholder="Select a Fiscal Year"
                  fluid
                  selection
                  options={transformedData.sort((a, b) => {
                    return b.key - a.key;
                  })}
                  loading={fetchingMainIncome}
                  onChange={this.getIncomeBrackets}
                />
              </GridColumn>
              <GridColumn width="4" floated="right" textAlign="right">
                <Popup
                  trigger={
                    <Button
                      content="Create"
                      onClick={this.createIncomeBracket}
                      disabled={isReadOnly || canCreateNew <= 0}
                      loading={fetchingCreate}
                    />
                  }
                  content={`for fiscal year ${canCreateNew}`}
                  on="hover"
                  open={this.state.isOpen}
                  onClose={this.handleClose}
                  onOpen={this.handleOpen}
                  position="top right"
                />
              </GridColumn>
              <GridColumn width="4" floated="right" textAlign="right">
                <Button
                  icon="refresh"
                  labelPosition="right"
                  content="Update"
                  onClick={this.createUpdate}
                  loading={fetchingUpdate}
                  disabled={isReadOnly || selectedFiscalYear === 0}
                />
              </GridColumn>
            </GridRow>
          </Grid>
        </Filter>
        <Main>
          <ReactTable
            data={incomeBrackets}
            getTheadThProps={() => {
              return {
                style: {
                  whiteSpace: 'pre-wrap',
                },
              };
            }}
            getTrProps={rowInfo => {
              return {
                style: {
                  textAlign: 'right',
                },
              };
            }}
            className={'-striped -highlight grid--fixed-row-height'}
            columns={columns}
            defaultPageSize={9}
            noDataText={'No Data Found'}
            showPagination={false}
            loading={fetchingIncomeBracket}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ IncomeBracketState }) => {
  return {
    mainIncomes: IncomeBracketState.mainIncomes,
    fetchingMainIncome: IncomeBracketState.fetchingMainIncome,
    fetchingIncomeBracket: IncomeBracketState.fetchingIncomeBracket,
    incomeBrackets: IncomeBracketState.incomeBrackets,
    fetchingUpdate: IncomeBracketState.fetchingUpdate,
    fetchingCreate: IncomeBracketState.fetchingCreate,
    apiResult: IncomeBracketState.apiResult,
    canCreateNew: IncomeBracketState.canCreateNew,
  };
};

export const IncomeBracket = withRouter(
  connect(
    mapStateToProps,
    {
      getMainIncome,
      getIncomeBracket,
      postCreateUpdate,
      getCanCreateNew,
    }
  )(IncomeBracketContainer)
);



// WEBPACK FOOTER //
// ./src/pages/incomebracket/IncomeBracket.js